import { RouteRecordRaw } from 'vue-router';
import BioManagerLayout from '@/components/tailwind/layout/bio/BioManagerLayout.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/bio',
    name: 'UserBioManagerPage',
    meta: {
      layout: BioManagerLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "bioManager" */ '@/views/tailwind/bio/BioManagerView.vue'),
  },
];

export default routes;
